// Import CSS
import "./styles.css"

const Icon = ({ src, size }) => {
  return (
    <img
      src={src}
      alt="icon"
      className={size}/>
  );
};

export default Icon;